<template lang="pug">
  .the-map-header
    .header__wrapper
      .wrapper__logo
        img(src='../assets/playmetrix-logo.png')
      .wrapper__text
        .header__title
          b PlayMetrix
          |  дэлгэц суусан автобуснуудын байршил
        .header__subtitle
          b CLIX GPS
          |  систем ашиглан бодит хугацаанд харуулж байна.
</template>

<script>
export default {
  name: 'the-map-header'
}
</script>

<style scoped>
.the-map-header {
  position: absolute;
  z-index: 9;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px;
}
.header__wrapper {
  display: flex;
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,.3);
  border-radius: 3px;
  padding: 10px 10px 5px 10px;
}
.header__title {
  color: #2C3E50;
  margin-bottom: 5px;
  /* font-weight: 600; */
}
.header__subtitle {
  text-align: right;
  font-size: 0.8rem;
  color: #99A1AA;
}
.wrapper__logo img {
  width: 20px;
}
.wrapper__text {
  margin-left: 10px;
}
</style>